import React, { useState, useRef, useEffect } from 'react';
import { Button, Input } from 'antd';
import { useDebounce } from 'hooks/useDebounce';
import { ReactComponent as SearchIcon } from 'assets/icons/Search.svg';

interface SearchInputProps {
  placeholder?: string;
  onSearch: (keyword: string) => void;
  debounceMs?: number;
  width?: number;
  initialValue?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Rechercher',
  onSearch,
  debounceMs = 500,
  width = 400,
  initialValue = '',
}) => {
  const [value, setValue] = useState(initialValue);
  const debounced = useDebounce(value, debounceMs);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onSearch(debounced.trim());
  }, [debounced, onSearch]);

  return (
    <div className="flex" style={{ width }}>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        allowClear
        className="h-10 rounded-l-md rounded-r-none"
      />
      <Button className="h-10 flex items-center justify-center border-l-0 rounded-l-none rounded-r-md bg-white">
        <SearchIcon className="w-4 h-4 text-gray-500" />
      </Button>
    </div>
  );
};

export default SearchInput;
